export enum LinkedObjectType {
    Order = 'order',
    Sample = 'sample'
}
